import React from 'react';
import { Button } from 'react-bootstrap';

const Tramites = () => {
  return (
    <div className="tramites-container text-center m-4">
      <br></br>
            <br></br>


      <Button 
        // Si el PDF está en la carpeta 'public', usa la ruta directa así:
        href="/Pdf/TramitesyServicios.pdf" 
        
        // Si usaste el import de arriba, cambia el href por: href={pdfTramites}
        target="_blank" 
        rel="noopener noreferrer"
        variant="primary" // Puedes cambiarlo a "success", "danger", "dark", etc.
        size="lg" // Para hacer el botón un poco más grande
      >
        Ver Trámites y Servicios
      </Button>
    </div>
  );
};

export default Tramites;